<template>
  <div class="exam-list" v-loading="loading">
    <ul>
      <li v-for="(item,index) in list" :key="index">
        <div class="exam-box">
          <div class="exam-list-left">
            <div class="exam-list-left-img lms-center">
              <img src="@p/assets/images/exam.png" alt="">
            </div>
            <div class="exam-list-left-text">
              <h3>{{item.exam}}</h3>
              <ul>
                <li>試卷編號：{{item.serial_number}}</li>
                <li>出題人：{{item.created_by}}</li>
                <li v-if="type !== 0">考試時間：{{apply_begin_date}} 至 {{apply_of_date}}</li>
              </ul>
            </div>
          </div>
          <div class="exam-list-right">
            <div>
              <p>剩余總考試次數<span>{{max_times - item.history_count >= 0 ? max_times-item.history_count : 0}}</span>次</p>
              <p v-if="everyday_times">當天剩餘考試次數<span>{{everyday_times - item.day_history_count >= 0 ? everyday_times-item.day_history_count : 0}}</span>次</p>
            </div>
            <div>
              <el-button v-if="item.status === 1 && exam_status === 1" @click="examClick($route.query.index,item)" :type="setBtnText(item) == listText[0] ? 'info' : 'primary'">
                {{setBtnText(item)}}
              </el-button>
              <el-tooltip v-else class="item" effect="dark" :content="`${exam_status != 1 ? '考試' : '試卷'}已停用，僅可查看成績`" placement="top-end">
                <el-button type="info">开始考试</el-button>
              </el-tooltip>
              <br>
              <el-button @click="goResultList(item)" type="warning" plain>查看成绩</el-button>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
      </li>
    </ul>
    <Empty v-if="!list.length && !loading" title="暫無結果" :img="require('@p/assets/images/resultEmpty.png')" />
  </div>
</template>
<script>
import { formatIosDateTime } from '@/utils';
import Empty from '@p/components/contentEmpty';
export default {
  components: { Empty },
  data () {
    return {
      loading: true,
      listText: ['考试结束', '开始考试', '考试未开始'],
      list: [],
      time_duration: '',                               //考试时间
      max_times: '',                                   //考试最大次数
      everyday_times: '',                              //每天最大次数
      apply_begin_date: '',
      apply_of_date: '',
      type: 0, // 0 依赖课堂 1 不依赖课堂
      answer_parsing_status: 0,
      details_status: 0, // 0 隐藏详情 1 显示详情
      exam_status: 1,
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData (page_size = 9999, page = 1) {
      this.loading = true;
      await this.$http.examination.examPaper({ id: this.$route.query.id, page_size, page }).then(v => {
        if (v.status === 200 && v.data.status_code === 200) {
          this.list = v.data.data.exam;
          this.time_duration = v.data.data.time_duration;
          this.max_times = v.data.data.max_times;
          this.everyday_times = v.data.data.everyday_times;
          this.apply_begin_date = v.data.data.apply_begin_date;
          this.apply_of_date = v.data.data.apply_of_date;
          this.type = v.data.data.type;
          this.answer_parsing_status = v.data.data.answer_parsing_status;
          this.details_status = v.data.data.details_status;
          this.exam_status = v.data.data.status;
        }
        this.loading = false;
      }).catch(er => { this.loading = false; })
    },
    setBtnText (item) {
      if (this.$route.query.index == 0) {
        if (this.isExamStart(item)) {
          return this.listText[1];
        } else {
          return this.listText[0];
        }
      } else if (this.max_times - item.history_count <= 0 && this.$route.query.index == 1) {
        return this.listText[0];
      } else if (this.$route.query.index == 2 && (this.type == 0 || this.isDateStart(item))) {
        return this.listText[1];
      } else {
        return this.listText[this.$route.query.index];
      }
    },
    examClick (v, item) {
      if (v == 0) { // 已結束
        if (this.everyday_times !== null && this.everyday_times - item.day_history_count <= 0) {
          this.$message({
            message: '當天剩餘考試次數為0，無法考試',
            center: true,
            type: 'error'
          });
        } else if (this.isExamStart(item)) {
          this.goQuestions(item);
        }
      } else if (v == 2) { // 未開始
        if (this.isHasNumber(item)) {
          return;
        } else if (this.type === 0 || this.isDateStart(item)) {
          this.goQuestions(item);
        } else {
          this.$message({
            message: '当前考试还未开始！',
            center: true,
            type: 'error'
          });
        }
      } else { // 考試中
        if (this.isHasNumber(item)) {
          return;
        }
        this.goQuestions(item);
      }
    },
    isHasNumber (item) {
      if (this.max_times - item.history_count <= 0) {
        this.$message({
          message: '剩余考試次數0次!',
          center: true,
          type: 'error'
        });
        return true;
      } else if (this.everyday_times !== null && this.everyday_times - item.day_history_count <= 0) {
        this.$message({
          message: '當天剩餘考試次數為0，無法考試',
          center: true,
          type: 'error'
        });
        return true;
      }
      return false;
    },
    goQuestions (item) {
      this.$router.push({
        path: '/exam/questions', query: {
          id: item.id,
          time: this.time_duration,
          examination_id: this.$route.query.id,                //考试ID
          apply_begin_date: this.apply_begin_date,
          apply_of_date: this.apply_of_date,
          title: item.exam,
          type: this.type
        }
      })
    },
    goResultList (item) {
      this.$router.push({ path: '/exam/result-list', query: { exam_id: item.id, examination_id: this.$route.query.id, title: item.exam, status: this.answer_parsing_status, details: this.details_status } })
    },
    isExamStart (item) {
      return ((((this.max_times - item.history_count > 0) && this.$route.query.index == 0)
        && ((this.type === 0) || (this.type === 1 && (new Date() < new Date(formatIosDateTime(this.apply_of_date)))))));
    },
    isDateStart (item) {
      return new Date() > new Date(formatIosDateTime(this.apply_begin_date));
    }
  }
}
</script>
<style lang="less" scoped>
.exam-list {
  padding-bottom: 30px;
  .exam-box {
    height: 103px;
    display: flex;
    justify-content: space-between;
  }
  > ul {
    margin-top: 30px;
  }
  &-left {
    display: flex;
    &-img {
      height: 103px;
      width: 131px;
      border: 1px solid rgba(234, 234, 243, 1);
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
    &-text {
      padding-left: 20px;
      h3 {
        color: #404040;
        font-size: 16px;
        margin-bottom: 10px;
      }
      > ul > li {
        line-height: 18px;
        font-size: 13px;
        color: rgba(51, 51, 51, 0.5);
      }
    }
  }
  &-right {
    display: flex;
    align-items: center;
    p {
      text-align: right;
      margin-right: 36px;
      font-size: 14px;
      color: rgba(64, 64, 64, 1);
      margin-bottom: 5px;
      span {
        color: #f7971e;
        padding: 0 5px;
      }
    }
    .el-button {
      width: 120px;
      margin-bottom: 5px;
      span {
        font-size: 14px;
      }
    }
  }
}
</style>